import { MODEL_KEY } from "@/modules/model";
import ModelIcon from "@/modules/model-icon";

export const TYPE_FILTER = [
  { name: "Asset", icon: <ModelIcon model={MODEL_KEY.ASSET} /> },
  { name: "Intervention", icon: <ModelIcon model={MODEL_KEY.INTERVENTION} /> },
  { name: "Observation", icon: <ModelIcon model={MODEL_KEY.OBSERVATION} /> },
] as const;
